var _circle, _ellipse, _ellipse2, _line, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmotionBlankface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 372,
    viewBox: "0 0 290 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144.833,
    cy: 144.833,
    r: 144.833,
    fill: "url(#paint0_radial_1486_9733)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.5938,
    cy: 126.229,
    rx: 10.375,
    ry: 15.2877,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 194.422,
    cy: 126.229,
    rx: 10.375,
    ry: 15.2877,
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 117.156,
    y1: 199.668,
    x2: 172.852,
    y2: 199.668,
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.84 352.067H61.7896V347.147H113.84V352.067ZM90.6396 371.364H84.7046V350.194H90.6396V371.364ZM107.271 339.943H68.2959V317.536H107.271V339.943ZM74.231 335.214H101.272V322.392H74.231V335.214ZM138.057 361.366H131.995V345.307H138.057V361.366ZM155.767 361.398H149.768V345.338H155.767V361.398ZM170.081 364.635H118.03V359.716H170.081V364.635ZM165.32 324.455H122.441V319.535H165.32V324.455ZM165.161 347.084H122.632V342.165H165.161V347.084ZM137.073 343.085H131.074V323.534H137.073V343.085ZM156.655 343.085H150.72V323.534H156.655V343.085ZM217.307 333.944H205.024V328.993H217.307V333.944ZM221.624 348.354H215.593V314.489H221.624V348.354ZM202.549 349.972C206.548 349.972 209.986 350.395 212.864 351.242C215.763 352.088 217.974 353.315 219.497 354.923C221.042 356.51 221.814 358.425 221.814 360.668C221.814 362.911 221.042 364.826 219.497 366.413C217.974 368.021 215.763 369.248 212.864 370.094C209.986 370.941 206.548 371.374 202.549 371.396C198.592 371.374 195.175 370.941 192.297 370.094C189.42 369.248 187.209 368.021 185.664 366.413C184.119 364.826 183.347 362.911 183.347 360.668C183.347 358.425 184.119 356.51 185.664 354.923C187.209 353.315 189.42 352.088 192.297 351.242C195.175 350.395 198.592 349.972 202.549 349.972ZM202.549 354.606C199.819 354.606 197.45 354.849 195.439 355.336C193.451 355.801 191.927 356.489 190.869 357.399C189.832 358.309 189.314 359.398 189.314 360.668C189.314 361.895 189.832 362.964 190.869 363.874C191.927 364.783 193.451 365.482 195.439 365.968C197.45 366.434 199.819 366.667 202.549 366.667C205.342 366.667 207.722 366.434 209.69 365.968C211.679 365.482 213.192 364.783 214.229 363.874C215.286 362.964 215.815 361.895 215.815 360.668C215.815 359.398 215.286 358.309 214.229 357.399C213.192 356.489 211.679 355.801 209.69 355.336C207.722 354.849 205.342 354.606 202.549 354.606ZM193.408 324.645C193.408 328.136 192.752 331.437 191.44 334.547C190.15 337.658 188.298 340.387 185.886 342.736C183.474 345.063 180.649 346.83 177.412 348.036L174.27 343.212C177.148 342.196 179.655 340.726 181.792 338.8C183.95 336.875 185.601 334.685 186.743 332.23C187.886 329.755 188.457 327.226 188.457 324.645V320.233H193.408V324.645ZM194.551 324.582C194.551 326.972 195.101 329.3 196.201 331.564C197.301 333.807 198.888 335.817 200.962 337.594C203.035 339.35 205.469 340.715 208.262 341.688L205.183 346.481C201.988 345.36 199.227 343.699 196.899 341.498C194.572 339.298 192.784 336.737 191.536 333.817C190.287 330.876 189.663 327.798 189.663 324.582V320.233H194.551V324.582ZM206.802 323.375H176.079V318.393H206.802V323.375Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1486_9733",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.833 144.833) rotate(90) scale(144.833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmotionBlankface);
export default __webpack_public_path__ + "static/media/IconEmotionBlankface.336a9acd5f643a945c2c65872e1e250b.svg";
export { ForwardRef as ReactComponent };